function convertJaDate(date) {
  const raw_date = date.substr(0, 10);
  const raw_time = date.substr(11, 5);

  const raw_date_array = raw_date.split("-");
  const raw_time_array = raw_time.split(":");
  const ja_date =
    raw_date_array[0] +
    "年" +
    raw_date_array[1] +
    "月" +
    raw_date_array[2] +
    "日";
  const ja_time = raw_time_array[0] + "時" + raw_time_array[1] + "分";

  return { ja_date, ja_time };
}

// e.g. ja_date: "2020/09/08" ja_time: "12:20"
function convertSlashFullDate(date) {
  const raw_date = date.substr(0, 10);
  const raw_time = date.substr(11, 5);

  const raw_date_array = raw_date.split("-");
  const raw_time_array = raw_time.split(":");
  const ja_date =
    raw_date_array[0] + "/" + raw_date_array[1] + "/" + raw_date_array[2];
  const ja_time = raw_time_array[0] + ":" + raw_time_array[1];

  return { ja_date, ja_time };
}

// e.g. ja_date: "09/08"
function convertSlashDate(date) {
  const raw_date = date.substr(0, 10);

  const raw_date_array = raw_date.split("-");
  const ja_date = raw_date_array[1] + "/" + raw_date_array[2];

  return ja_date;
}

export default { convertJaDate, convertSlashFullDate, convertSlashDate };
